import {Injectable} from "@angular/core";
import {ApiBaseService} from "@portal/api/api-base-service";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {SignatureData} from "@portal/api/responses/dtc-removal/signature-data";

// Interface for the DTC module submit response
export interface DtcModuleSubmitResponse {
    fileBytes: number[] | Uint8Array; // C# byte array becomes number[] in JSON
    fileName: string;
    contentType: string;
    appliedPatches: string[];
    totalPatchesApplied: number;
    totalPatchesAttempted: number;
}

@Injectable({
    providedIn: 'root'
})
export class DtcModuleService extends ApiBaseService {
    controller = 'dtc-module';

    constructor(
        private _httpClient: HttpClient,
) {
        super(_httpClient);
    }

    submit(formData : FormData): Observable<HttpResponse<Blob | DtcModuleSubmitResponse>> {
        return this.postMultipartOptions(`${this.controller}/submit`, formData, { responseType: 'json', observe: 'response'});
    }

    checkFile(formData : FormData): Observable<HttpResponse<SignatureData>> {
        // add check file endpoint multipart and process events to progress bar
        return this.postMultipartOptions(`${this.controller}/check-file`, formData, { responseType: 'json' as 'json', observe: 'events'});
    }

    sendToSupport(formData : FormData): Observable<HttpResponse<Blob>> {
        return this.postMultipartOptions(`${this.controller}/send-to-support`, formData, { responseType: 'blob' as 'json', observe: 'response'});
    }
}
